import { RootState } from 'store/reducer';
import { VisitorsEmailsState } from './types';
import { createSelector } from 'reselect';

export const visitorsEmailsSelector = (state: RootState): VisitorsEmailsState => state.visitorsEmails;

export const selectAllVisitorsEmails = createSelector([visitorsEmailsSelector], visitorsEmails => visitorsEmails);
